import { get, isString } from 'lodash';
import { IsJsonString } from './index';
import { toast } from 'sonner';

export const getError = (error) => {
  return error?.response?.data?.body || error.toString();
};

export const showError = (error, { ignore500Error = false } = { ignore500Error: false }) => {
  console.log('error', error);
  if (error?.ignoreShowMessage || error?.isCanceled || error?.code === 'ERR_CANCELED') {
    return;
  }

  //* Some APIs dont need show the toast if API 5xx
  if (ignore500Error) {
    if (error?.response?.status >= 500 && error?.response?.status <= 599) {
      return;
    }
  }

  const nameFieldsErrorFromServer = [
    'response.data.error',
    'response.data.reason',
    'response.data.body',
    'response.data.message',
    'response.data',
    'message',
  ];

  for (let i = 0; i < nameFieldsErrorFromServer.length; i++) {
    const field = nameFieldsErrorFromServer[i];
    const errorMsg = get(error, field);
    if (!!errorMsg) {
      if (IsJsonString(errorMsg)) {
        const jsonParsed = JSON.parse(errorMsg) || {};
        const message =
          get(jsonParsed, 'reason') ||
          get(jsonParsed, 'errorMessage') ||
          get(jsonParsed, 'error') ||
          get(jsonParsed, 'message');

        toast.error(message);
        return;
      }

      if (isString(errorMsg)) {
        toast.error(errorMsg);
        return;
      }
    }
  }

  toast.error(error.toString());
};

export const renderErrorForFormik = (error) => {
  if (typeof error === 'object') {
    return;
  }

  return error;
};

export const catchErrorOTPNotEnable = (otpResponse) => {
  if (isString(otpResponse?.data?.message) && !otpResponse?.data?.message.includes('Pending OTP')) {
    showError(otpResponse?.data?.message);
    return true;
  }

  return false;
};
